"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBarDropdownMenu = void 0;
const React = __importStar(require("react"));
const Icon_1 = __importDefault(require("../../Icon/Icon"));
const SearchBarDropdownMenu = ({ isDisabled, actions, }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const toggleOpen = () => setIsOpen(!isOpen);
    const close = () => setIsOpen(false);
    const dropdownRef = React.useRef(null);
    return (React.createElement("div", { className: "search-bar-dropdown" },
        renderMenuButton(),
        renderDropdownMenu()));
    function renderMenuButton() {
        const disabled = isDisabled ? '-disabled' : '';
        return (React.createElement("button", { className: `dropdown-button${disabled}`, onClick: toggleOpen, disabled: isDisabled, type: "button" }, renderButtonSvg()));
    }
    function renderDropdownMenu() {
        if (!isOpen) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "desktop-actions-overlay-div", onClick: handleClickOutside }),
            React.createElement("div", { ref: dropdownRef },
                React.createElement("ul", null, actions.map((action) => {
                    return (React.createElement(DropdownRow, { action: action, close: close, key: action.label }));
                })))));
    }
    function handleClickOutside(e) {
        if (dropdownRef.current) {
            if (!dropdownRef.current.contains(e.target)) {
                close();
            }
        }
    }
    function renderButtonSvg() {
        return (React.createElement("svg", null,
            React.createElement("circle", { id: "Oval-3", cx: "13", cy: "5", r: "2" }),
            React.createElement("circle", { id: "Oval-2", cx: "13", cy: "13", r: "2" }),
            React.createElement("circle", { id: "Oval-1", cx: "13", cy: "21", r: "2" })));
    }
};
exports.SearchBarDropdownMenu = SearchBarDropdownMenu;
const DropdownRow = ({ action, close }) => {
    return (React.createElement("li", { key: action.label, onClick: action.disabled ? undefined : click, className: action.disabled ? 'searchbar-dropdown-row-disabled' : '' },
        action.icon && React.createElement(Icon_1.default, { icon: action.icon }),
        action.label));
    function click() {
        action.action();
        close();
    }
};
//# sourceMappingURL=SearchBarDropdownMenu.js.map